module.exports = __webpack_public_path__ + "static/media/dollar.72d132e9.png";